(() => {
        const getMainContainer = () => {
          const form = document.querySelector('form[action*="/cart/add"]');
          return form ? form.closest('.product-section, .product__info-wrapper, .product__info-container, [id^="ProductInfo-"], .shopify-section') || form : null;
        };

        const initTracking = () => {
          let container = getMainContainer();
          if (!container) return;

          const priceFormatter = new Intl.NumberFormat('pl-PL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          const oldPriceSelector = 's, del, strike, [class*="compare"], [class*="old"]';
          const skippedPriceSelector = 's, del, strike, .hidden, .price--hidden, [style*="display: none"]';
          const watchedSelector = 'price, .price, .price-item--sale, .price__sale, .price-sale, .price-item--regular, .product__price, [data-product-price], .st-main-wrapper';
          const observerOptions = { childList: true, subtree: true, characterData: true };
          let lastTotal = -1;
          let debounceTimer = 0;
          let frameId = 0;
          let resetTimer = 0;
          let busyButton = null;
          let upsellWidget = null;

          const parsePrice = (text) => {
            if (!text) return 0;
            let cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '.');
            const parts = cleaned.split('.');
            if (parts.length > 1) {
              const decimalPart = parts.pop();
              cleaned = parts.join('') + '.' + decimalPart;
            }
            return parseFloat(cleaned) || 0;
          };

          const getCleanPriceText = (element) => {
            /* Zwykła cena nie wymaga kopiowania drzewa DOM. */
            if (!element.querySelector(oldPriceSelector)) return element.textContent;
            const clone = element.cloneNode(true);
            clone.querySelectorAll(oldPriceSelector).forEach((node) => node.remove());
            return clone.textContent;
          };

          const getMainPrice = () => {
            const priceNode = container.querySelector('price');
            if (priceNode) return parsePrice(priceNode.textContent);

            const salePrices = container.querySelectorAll('.price-item--sale, .price__sale .price-item, .price-sale');
            for (const element of salePrices) {
              if (!element.closest(skippedPriceSelector)) return parsePrice(getCleanPriceText(element));
            }

            const regularPrices = container.querySelectorAll('.price-item--regular, .product__price, [data-product-price]');
            for (const element of regularPrices) {
              if (!element.closest(skippedPriceSelector)) return parsePrice(getCleanPriceText(element));
            }
            return null;
          };

          const getUpsellPrice = () => {
 
            if (!container) return 0;
            const form = container.matches('form')
            ? container
            : container.querySelector('form[action*="/cart/add"]');
            if (!form) return 0;
            let totalGrosze = 0;
            for (const select of form.elements) {
              if (!select.matches('.st-variant-select') || select.disabled) continue;
              const checkbox = select.closest('.st-main-wrapper')
              ?.querySelector('.st-toggle-checkbox');
              if (!checkbox?.checked) continue;
              const price = Number(select.options[select.selectedIndex]?.dataset.price);
              if (Number.isFinite(price) && price >= 0) {
                totalGrosze += Math.round(price * 100);
              }
            }

            return totalGrosze / 100;
          };

          const affectsPrice = (record) => {
            const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            if (target && target.closest(watchedSelector)) return true;
            if (record.type !== 'childList') return false;
            const includesPrice = (node) => node.nodeType === 1 && (
              node.matches(watchedSelector) || node.querySelector(watchedSelector)
            );
            return Array.from(record.addedNodes).some(includesPrice) || Array.from(record.removedNodes).some(includesPrice);
          };

          const observer = new MutationObserver((records) => {
            if (records.some(affectsPrice)) triggerUpdate();
          });

          const refreshTargets = () => {
            const currentContainer = container && container.isConnected ? container : getMainContainer();
            const currentUpsell = upsellWidget && upsellWidget.isConnected
              ? upsellWidget : document.querySelector('.st-main-wrapper');

            if (currentContainer !== container || currentUpsell !== upsellWidget) {
              observer.disconnect();
              container = currentContainer;
              upsellWidget = currentUpsell;
              if (container) observer.observe(container, observerOptions);
              if (upsellWidget && (!container || !container.contains(upsellWidget))) {
                observer.observe(upsellWidget, observerOptions);
              }
            }
          };

          const writeText = (text) => {
            cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(() => {
              // Only the checkout needs this inherited property. Updating the
              // product container makes every form field recalculate its style.
              const label = JSON.stringify(text);
              container?.querySelectorAll('.shopify-payment-button').forEach(payment => {
                const button = payment.querySelector('[data-st-checkout]');
                const target = button || payment;
                if (target.style.getPropertyValue('--dynamic-btn-text') !== label) {
                  target.style.setProperty('--dynamic-btn-text', label);
                }
                if (button && button.getAttribute('aria-label') !== text) {
                  button.setAttribute('aria-label', text);
                }
              });
              frameId = 0;
            });
          };

          const updateButtonText = () => {
            if (busyButton) return;
            refreshTargets();
            if (!container) return;
            if (container.closest('product-info')?.hasAttribute('data-zb-unavailable')) {
              lastTotal = -1;
              writeText(window.variantStrings?.unavailable || 'Wariant niedostępny');
              return;
            }
            const mainPrice = getMainPrice();
            if (mainPrice === null) return;
            const total = mainPrice + getUpsellPrice();
            if (total < 0 || total === lastTotal) return;
            writeText('PRZEJDŹ DO PŁATNOŚCI - ' + priceFormatter.format(total) + ' zł');
            lastTotal = total;
          };

          function triggerUpdate() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(updateButtonText, 250);
          }

          const handleInput = (event) => {
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (!container || !container.isConnected) refreshTargets();
            if ((container && container.contains(target)) || target.closest('.st-main-wrapper')) triggerUpdate();
          };

          const resetPaymentState = () => {
            clearTimeout(resetTimer);
            if (busyButton) busyButton.style.opacity = '1';
            busyButton = null;
            lastTotal = -1;
            updateButtonText();
          };

          observer.observe(container, observerOptions);
          refreshTargets();
          document.addEventListener('change', handleInput);
          document.addEventListener('input', handleInput);

          document.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) return;
            const paymentButton = event.target.closest('.shopify-payment-button__button');
            if (!paymentButton) return;

            clearTimeout(resetTimer);
            clearTimeout(debounceTimer);
            if (busyButton && busyButton !== paymentButton) busyButton.style.opacity = '1';
            busyButton = paymentButton;
            writeText('WERYFIKACJA ZAMÓWIENIA...');
            paymentButton.style.opacity = '0.7';
            resetTimer = setTimeout(resetPaymentState, 2000);
          }, { capture: true, passive: true });

          window.addEventListener('pageshow', (event) => {
            if (event.persisted) resetPaymentState();
          });

          updateButtonText();
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initTracking, { once: true });
        } else {
          initTracking();
        }
      })();
